import { Map } from 'immutable';

const initialState = new Map({ inProgress: true });

export default function reducer(state = initialState, { type }) {
  switch (type) {
    case 'PERSIST_START':
      return state.set('inProgress', true);
    case 'PERSIST_FINISH':
      return state.set('inProgress', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/persist/reducer.js